import axios from "axios";
import "../styles/MenuPageStyles/menuStyle.css";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../config";
import Footer from "../components/Footer";
import { Card, Collapse, Nav, NavItem, NavLink, Row } from "reactstrap";
import classnames from "classnames";
import addImg from "../assets/MenuPage/addImg.jpg";
import swal from "sweetalert";
import ReactPaginate from "react-paginate";
import rollzMenu from "../assets/MenuCard.pdf";
import Loader from "../utils/Loader";
import { Helmet } from "react-helmet";

const NewMenuPage = ({ categoryList = [] }) => {
  const location = useLocation();
  const main_url = location.pathname.split("/").slice(-1);
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [menuOffer, setMenuOffer] = useState("");
  const [introTitle, setIntroTitle] = useState("");
  const [introDesc, setIntroDesc] = useState("");

  const [showCat, setShowCat] = useState(false);
  const[activeState, setActiveState] = useState("")

  const { category_name } = useParams();
  // console.log("category_name 4445454", category_name)

  useEffect(() => {
    onMenuItem();
    setActiveState(category_name);
  }, []);

  // console.log("category_name",category_name)
  // useEffect(() => {
  //   setActiveState(category_name);
  // }, []);

  const [rolledIceCreamsData, setrolledIceCreamsData] = useState([])

  // fetch Menu Items
  const onMenuItem = async (e) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("location", localStorage.getItem("location"));
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/products`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        setAllData(response.data.data);
        setLoading(false);
        setMenuOffer(response.data?.menu_offers?.image);
        setIntroTitle(response.data?.menu_offers?.title);
        setIntroDesc(response.data?.menu_offers?.description);
       
        setrolledIceCreamsData(response.data?.rolled)

        // TO get All Subcategory data and show in Rolled Ice-cream 

        // const desiredSlugs = [
        //   "chocolate-&-mix--flavours",
        //   "cookies-&-cream",
        //   "fruit-flavours",
        //   "vegan-flavour",
        //   "coffee-flavours",
        //   "kulfi-flavours",
        //   "south-asian-flavours",
        //   "cake-flavours"
        // ];
        // const filtered = response.data.data?.filter(
        //   (subcat) => desiredSlugs.includes(subcat.menu_slug)
        // );
        // console.log("filtered", filtered)
        // setrolledIceCreamsData(filtered);

      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  
  // console.log("Rolledcate", rolledIceCreamsData)
  // console.log("category List", categoryList)


  const [menu_id, setMenuId] = useState(false);
  const navigate = useNavigate();


  //_____________________________________________________

  // useEffect(() => {
  //   if (category_name && allData.length) {
  //     const Rollz = allData.filter((res) => res.menu_slug === category_name);
  //     setData(Rollz);
  //   }
  // }, [allData, category_name]);

  
  useEffect(() => {
    if (category_name && allData.length) {
      if (category_name === 'rolled-ice-cream') {
        setData(rolledIceCreamsData);
      } else {
        const filtered = allData.filter(res => res.menu_slug === category_name);
        setData(filtered);
      }
      // console.log("allData", allData);
      // console.log("category_name", category_name);
    }
  }, [allData, category_name]);
  

  //_____________________________________________________

  const [person_name, setPersonName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({
    person_name_error: "",
    email_error: "",
  });

  const validateEmail = () => {
    let newError = {};
    // Check if the person_name is empty
    if (person_name === "") {
      newError.person_name_error = "Please Enter Name"; // Fixed from "newError ==" to "newError ="
    }

    // Check if the email is empty
    if (email === "") {
      newError.email_error = "Email is Required";
    } else if (!email || !/\S+@\S+\.\S+/.test(email)) {
      newError.email_error = "Please enter a valid email address";
    }

    // Set the error state if there's an error
    setErrors(newError);
    return Object.keys(newError).length === 0;
  };

  const onLocationMenu = async (e) => {
    e.preventDefault();

    if (validateEmail()) {
      setLoading(true);
      const formData = new FormData();
      formData.append("person_name", person_name);
      formData.append("customer_email", email);
      formData.append("location", localStorage.getItem("location") || 1);
      formData.append(
        "location_name",
        localStorage.getItem("location_name") || "Ajax"
      );
      formData.append("type", 0);

      try {
        const response = await axios({
          method: "post",
          url: `${config.apiUrl}/download_menu`,
          data: formData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }).then((response) => {
          setLoading(false);
          swal({
            icon: "success",
            text: "Menu is sent to your email successfully",
          }).then((data) => {
            setEmail("");
            setPersonName("");
          });
        });
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
  };


  const [storedLocation, setStoredLocation] = useState('')
  useEffect(() => {
    const locationStored = localStorage.getItem('location_name')?.toLowerCase()
    setStoredLocation(locationStored)
  }, [location.pathname])

// console.log("storedLocationcdcds",storedLocation)

  const metadata = {
    "ajax": {
      "rolled-ice-cream": {
        title: "Rolled Ice Cream Ajax - Fresh & Delicious Treats",
        description: "Experience the best-rolled ice cream in Ajax. Freshly made for your sweet cravings. Visit us now!",
        keywords: "rolled ice cream Ajax, ice cream near me Ajax, ice cream shop near me Ajax"
      },
      "milkshakes": {
        title:"Best Milkshakes Ajax | Creamy, Thick, Delicious Treats",
        description: "Looking for the best milkshakes near you in Ajax? Enjoy thick, creamy, and flavorful milkshakes only at Rollz Ice Cream Ajax. Try now!",
        keywords: "milkshake near me Ajax, best milkshakes near me Ajax"
      },
      "waffles": {
        title:"Belgian Waffles Ajax | Crispy, Fluffy, Best Near You",
        description: "Find the best Belgian waffles near you in Ajax. Fluffy inside, crispy outside, topped with your favorites. Visit Rollz Ice Cream today!",
        keywords: "best belgian waffles Ajax, belgian waffles near me Ajax"
      },
      "faloodas": {
        title:"Best Falooda Ajax | Exotic, Creamy Indian Dessert",
        description: "Craving falooda in Ajax? Enjoy the best exotic, creamy falooda near you with refreshing flavors and toppings at Rollz Ice Cream.",
        keywords: "faluda near me Ajax, Best falooda near me Ajax, best falooda near me Ajax"
      },
      "cheesecake": {
        title:"Cheesecake Ajax | Rich, Creamy, Ice Cream Blend",
        description: "Taste the best cheesecake in Ajax. Rich, creamy, and available as a dessert or ice cream only at Rollz Ice Cream Ajax!",
        keywords: "cheesecake near me Ajax , best cheesecake near me Ajax, Cheesecake ice cream Ajax"
      },
      "popping-soda": {
        title:"Popping Soda Ajax | Refreshing, Sweet, Fizzy Drinks",
        description: "Enjoy fizzy, flavorful popping sodas in Ellerslie Edmonton. Sweet and refreshing drinks only at Rollz Ice Cream!",
        keywords: "popping soda near me Ajax, popping soda toronto Ajax"
      },
    },
    "ellerslie-edmonton": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Ellerslie Edmonton | Sweet, Fresh, Live",
        description: "Experience rolled ice cream in Ellerslie Edmonton, handcrafted live with your favorite flavors at Rollz Ice Cream",
        keywords: "rolled ice cream Ellerslie Edmonton, ice cream near me Ellerslie Edmonton, ice cream shop near me Ellerslie Edmonton"
      },
      "milkshakes": {
        title:"Best Milkshakes Ellerslie Edmonton | Thick, Flavorful",
        description: "Satisfy your cravings with Ellerslie Edmontons thick, creamy, and flavorful milkshakes at Rollz Ice Cream. Taste the best today!",
        keywords: "milkshake near me Ellerslie Edmonton, best milkshakes near me Ellerslie Edmonton"
      },
      "waffles": {
        title:"Belgian Waffles Ellerslie Edmonton | Crispy & Sweet",
        description: "Try the crispiest, fluffiest Belgian waffles in Ellerslie Edmonton! Visit Rollz Ice Cream for a dessert you'll love!",
        keywords: "best belgian waffles Ellerslie Edmonton, belgian waffles near me Ellerslie Edmonton"
      },
      "faloodas": {
        title:"Best Falooda Ellerslie Edmonton | Exotic Indian Dessert",
        description: "Enjoy the taste of exotic falooda in Ellerslie Edmonton! Sweet, refreshing, and richRollz Ice Cream has it all!",
        keywords: "faluda near me Ellerslie Edmonton, Best falooda near me Ellerslie Edmonton, best falooda near me Ellerslie Edmonton"
      },
      "cheesecake": {
        title:"Cheesecake Ellerslie Edmonton | Creamy & Ice Cream Style",
        description: "Discover the creamiest cheesecake and cheesecake ice cream in Ellerslie Edmonton at Rollz Ice Cream. Indulge today!",
        keywords: "cheesecake near me Ellerslie Edmonton , best cheesecake near me Ellerslie Edmonton, Cheesecake ice cream Ellerslie Edmonton"
      },
      "popping-soda": {
        title:"Popping Soda Ellerslie Edmonton | Fizzy, Flavorful Fun",
        description: "Enjoy fizzy, flavorful popping sodas in Ellerslie Edmonton. Sweet and refreshing drinks only at Rollz Ice Cream!",
        keywords: "popping soda near me Ellerslie Edmonton, popping soda toronto Ellerslie Edmonton"
      },
    },

    "guelph": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Guelph | Fresh, Fun, Made-to-Order",
        description: "Discover the best-rolled ice cream in Guelph. Fresh, handcrafted rolls with your favorite flavors and toppings.",
        keywords: "rolled ice cream Guelph, ice cream near me Guelph, ice cream shop near me Guelph"
      },
      "milkshakes": {
        title:"Milkshakes Guelph | Thick, Creamy, Best Near You",
        description: "Indulge in Guelphs thick, creamy milkshakes. Blended fresh with rich flavors only at Rollz Ice Cream Guelph!",
        keywords: "milkshake near me Guelph, best milkshakes near me Guelph"
      },
      "waffles": {
        title:"Belgian Waffles Guelph | Crispy, Fluffy, Delicious",
        description: "Enjoy sweet, golden Belgian waffles in Guelph. Crisp outside, soft insideserved fresh at Rollz Ice Cream!",
        keywords: "best belgian waffles Guelph, belgian waffles near me Guelph"
      },
      "faloodas": {
        title:"Falooda Guelph | Best Indian Dessert Near You",
        description: "Taste Guelphs favorite Indian faloodasweet, creamy, and packed with flavor. Find it at Rollz Ice Cream!",
        keywords: "faluda near me Guelph, Best falooda near me Guelph, best falooda near me Guelph"
      },
      "cheesecake": {
        title:"Cheesecake Guelph | Creamy, Rich, Ice Cream Style",
        description: "Try the best cheesecake and cheesecake ice cream in Guelph at Rollzrich, smooth, and unforgettable!",
        keywords: "cheesecake near me Guelph , best cheesecake near me Guelph, Cheesecake ice cream Guelph"
      },
      "popping-soda": {
        title:"Popping Soda Guelph | Fizzy, Flavorful, Refreshing",
        description: "Sip our fizzy, flavorful popping sodas in Guelph. A fun and refreshing drink experience at Rollz Ice Cream!",
        keywords: "popping soda near me Guelph, popping soda toronto Guelph"
      },
    },

    "sherwood-park": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Sherwood Park | Fresh & Flavorful",
        description: "Experience handcrafted rolled ice cream at Rollz Sherwood Park. Fresh, fun, and full of flavor near you!",
        keywords: "rolled ice cream Sherwood Park, ice cream near me Sherwood Park, ice cream shop near me Sherwood Park"
      },
      "milkshakes": {
        title:"Milkshakes Sherwood Park | Thick, Rich & Creamy",
        description: "Enjoy thick, creamy milkshakes made fresh in Sherwood Park. Find your favorite flavors at Rollz Ice Cream!",
        keywords: "milkshake near me Sherwood Park, best milkshakes near me Sherwood Park"
      },
      "waffles": {
        title:"Belgian Waffles Sherwood Park | Golden & Fluffy",
        description: "Craving waffles in Sherwood Park? Enjoy golden Belgian waffles served with toppings at Rollz Ice Cream.",
        keywords: "best belgian waffles Sherwood Park, belgian waffles near me Sherwood Park"
      },
      "faloodas": {
        title:"Falooda Sherwood Park | Creamy, Sweet, Refreshing",
        description: "Cool off with sweet and creamy faloodas in Sherwood Park. A perfect exotic dessert from Rollz Ice Cream!",
        keywords: "faluda near me Sherwood Park, Best falooda near me Sherwood Park, best falooda near me Sherwood Park"
      },
      "cheesecake": {
        title:"Cheesecake Sherwood Park | Rich, Creamy, Ice Cream",
        description: "Dive into rich cheesecake and cheesecake ice cream at Rollz Ice Cream in Sherwood Park. Indulgence awaits!",
        keywords: "cheesecake near me Sherwood Park , best cheesecake near me Sherwood Park, Cheesecake ice cream Sherwood Park"
      },
      "popping-soda": {
        title:"Popping Soda Sherwood Park | Fizzy, Sweet, Fun",
        description: "Enjoy fizzy, popping sodas bursting with flavor in Sherwood Park. Refresh your taste at Rollz Ice Cream today!",
        keywords: "popping soda near me Sherwood Park, popping soda toronto Sherwood Park"
      },
    },

    "windsor": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Windsor | Handcrafted & Delicious",
        description: "Discover Windsor's top spot for rolled ice cream! Freshly prepared with your favorite flavors at Rollz Ice Cream.",
        keywords: "rolled ice cream Windsor, ice cream near me Windsor, ice cream shop near me Windsor"
      },
      "milkshakes": {
        title:"Best Milkshakes Windsor | Thick, Creamy, Flavorful",
        description: "Enjoy Windsors best milkshakes! Thick, creamy, and made fresh with exciting flavors. Visit Rollz Ice Cream in Windsor now!",
        keywords: "milkshake near me Windsor, best milkshakes near me Windsor"
      },
      "waffles": {
        title:"Belgian Waffles Windsor | Fluffy, Sweet, Best Near Me",
        description: "Craving waffles in Windsor? Try our fluffy, sweet Belgian waffles at Rollz Ice Cream Windsor. The perfect dessert treat is here!",
        keywords: "best belgian waffles Windsor, belgian waffles near me Windsor"
      },
      "faloodas": {
        title:"Best Falooda Windsor | Indian-Style Dessert Delights",
        description: "Taste authentic Indian-style falooda in Windsor! Sweet, creamy, and exoticonly at Rollz Ice Cream Windsor. Try it now!",
        keywords: "faluda near me Windsor, Best falooda near me Windsor, best falooda near me Windsor"
      },
      "cheesecake": {
        title:"Cheesecake Windsor | Rich, Creamy, Ice Cream Delight",
        description: "Indulge in the best cheesecake desserts in Windsor! Rich, creamy, and also as ice cream. Visit Rollz Ice Cream Windsor today!",
        keywords: "cheesecake near me Windsor , best cheesecake near me Windsor, Cheesecake ice cream Windsor"
      },
      "popping-soda": {
        title:"Popping Soda Windsor | Fizzy, Fun, Flavor-Packed Drink",
        description: "Sip on Windsors most exciting fizzy drink! Try our sweet and refreshing popping soda flavors only at Rollz Ice Cream.",
        keywords: "popping soda near me Windsor, popping soda toronto Windsor"
      },
    },

    "kitchener": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Kitchener | Fun, Fresh, Handcrafted",
        description: "Discover Kitcheners favorite rolled ice cream. Freshly crafted with premium ingredients, only at Rollz Ice Cream!",
        keywords: "rolled ice cream Kitchener, ice cream near me Kitchener, ice cream shop near me Kitchener"
      },
      "milkshakes": {
        title:"Milkshakes Kitchener | Thick, Creamy, Refreshing",
        description: "Enjoy the creamiest milkshakes in Kitchener! Made fresh with rich flavors at Rollz Ice Cream. Visit today!",
        keywords: "milkshake near me Kitchener, best milkshakes near me Kitchener"
      },
      "waffles": {
        title:"Belgian Waffles Kitchener | Fluffy, Golden, Delicious",
        description: "Savor fluffy, golden Belgian waffles in Kitchener. Topped with fresh fruits, syrup, and moreonly at Rollz Ice Cream!",
        keywords: "best belgian waffles Kitchener, belgian waffles near me Kitchener"
      },
      "faloodas": {
        title:"Falooda Kitchener | Indian Dessert | Sweet & Creamy",
        description: "Cool down with sweet, creamy falooda in Kitchener. Perfectly made with exotic flavors at Rollz Ice Cream!",
        keywords: "faluda near me Kitchener, Best falooda near me Kitchener, best falooda near me Kitchener"
      },
      "cheesecake": {
        title:"Cheesecake Kitchener | Rich, Creamy, Ice Cream Style",
        description: "Dive into rich, creamy cheesecake or cheesecake ice cream in Kitchener. Available now at Rollz Ice Cream!",
        keywords: "cheesecake near me Kitchener , best cheesecake near me Kitchener, Cheesecake ice cream Kitchener"
      },
      "popping-soda": {
        title:"Popping Soda Kitchener | Fizzy, Sweet, Refreshing",
        description: "Try fizzy popping sodas in Kitchener! Refreshing and fun flavors await you at Rollz Ice Cream. Dont miss out!",
        keywords: "popping soda near me Kitchener, popping soda toronto Kitchener"
      },
    },

    "kingston": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Kingston | Handmade, Sweet, Unique",
        description: "Taste fresh rolled ice cream in Kingston, made before your eyes with bold flavors and creamy textures at Rollz!",
        keywords: "rolled ice cream Kingston, ice cream near me Kingston, ice cream shop near me Kingston"
      },
      "milkshakes": {
        title:"Milkshakes Kingston | Thick, Creamy, Made Fresh",
        description: "Treat yourself to the creamiest milkshakes in Kingston. Blended fresh with the best flavors at Rollz Ice Cream!",
        keywords: "milkshake near me Kingston, best milkshakes near me Kingston"
      },
      "waffles": {
        title:"Belgian Waffles Kingston | Golden, Fluffy & Tasty",
        description: "Bite into golden, fluffy Belgian waffles in Kingston. A perfect sweet treat, freshly served at Rollz Ice Cream.",
        keywords: "best belgian waffles Kingston, belgian waffles near me Kingston"
      },
      "faloodas": {
        title:"Falooda Kingston | Indian Dessert | Sweet & Creamy",
        description: "Discover exotic falooda desserts in Kingstonlayered with flavor and tradition, only at Rollz Ice Cream!",
        keywords: "faluda near me Kingston, Best falooda near me Kingston, best falooda near me Kingston"
      },
      "cheesecake": {
        title:"Cheesecake Kingston | Rich, Creamy, Sweet & Smooth",
        description: "Enjoy decadent cheesecake and cheesecake ice cream in Kingston. Made fresh and creamy at Rollz Ice Cream!",
        keywords: "cheesecake near me Kingston , best cheesecake near me Kingston, Cheesecake ice cream Kingston"
      },
      "popping-soda": {
        title:"Popping Soda Kingston | Fizzy, Sweet, Unique Drinks",
        description: "Refresh yourself with fizzy popping sodas in Kingston. Bursting with sweet flavor and fun at Rollz Ice Cream!",
        keywords: "popping soda near me Kingston, popping soda toronto Kingston"
      },
    },

    "scarborough": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Scarborough | Fresh, Fun, Flavorful",
        description: "Try delicious rolled ice cream in Scarborough made live with tasty flavors and toppings. Only at Rollz Ice Cream!",
        keywords: "rolled ice cream Scarborough, ice cream near me Scarborough, ice cream shop near me Scarborough"
      },
      "milkshakes": {
        title:"Milkshakes Scarborough | Creamy, Thick & Fresh",
        description: "Sip the best milkshakes in Scarborough! Rich, thick blends made fresh at Rollz Ice Cream with fun flavors.",
        keywords: "milkshake near me Scarborough, best milkshakes near me Scarborough"
      },
      "waffles": {
        title:"Belgian Waffles Scarborough | Fluffy, Golden, Sweet",
        description: "Fluffy, golden Belgian waffles await in Scarborough. Topped your way at Rollz Ice Creamvisit us today!",
        keywords: "best belgian waffles Scarborough, belgian waffles near me Scarborough"
      },
      "faloodas": {
        title:"Falooda Scarborough | Creamy, Cool, Indian Dessert",
        description: "Enjoy the best falooda in Scarborough! A sweet, creamy Indian treat full of texture, only at Rollz Ice Cream.",
        keywords: "faluda near me Scarborough, Best falooda near me Scarborough, best falooda near me Scarborough"
      },
      "cheesecake": {
        title:"Cheesecake Scarborough | Rich, Creamy, Dessert Bliss",
        description: "Scarboroughs creamiest cheesecake and ice cream blendonly at Rollz Ice Cream. Indulge in sweet perfection!",
        keywords: "cheesecake near me Scarborough , best cheesecake near me Scarborough, Cheesecake ice cream Scarborough"
      },
      "popping-soda": {
        title:"Popping Soda Scarborough | Fizzy, Sweet, Refreshing",
        description: "Try fizzy, flavorful popping sodas in Scarborough. Refreshing drinks to pair with any dessert at Rollz Ice Cream!",
        keywords: "popping soda near me Scarborough, popping soda toronto Scarborough"
      },
    },
    "north-park-drive-brampton": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Brampton | Fresh, Handcrafted Fun",
        description: "Experience handcrafted rolled ice cream in Brampton. Made fresh with fun toppings and bold flavors at Rollz!",
        keywords: "rolled ice cream Brampton, ice cream near me Brampton, ice cream shop near me Brampton"
      },
      "milkshakes": {
        title:"Milkshakes Brampton | Thick, Creamy & Irresistible",
        description: "Taste Bramptons best milkshakes! Rich, creamy, and blended fresh at Rollz Ice Creamyour sweet escape!",
        keywords: "milkshake near me Brampton, best milkshakes near me Brampton"
      },
      "waffles": {
        title:"Belgian Waffles Brampton | Fluffy, Crisp & Sweet",
        description: "Dig into fluffy Belgian waffles in Brampton! Crisp edges, soft center, and perfect toppings await at Rollz.",
        keywords: "best belgian waffles Brampton, belgian waffles near me Brampton"
      },
      "faloodas": {
        title:"Falooda Brampton | Sweet, Creamy Indian Dessert",
        description: "Enjoy the best falooda in Bramptoncreamy, textured, and packed with flavor. Served fresh at Rollz Ice Cream.",
        keywords: "faluda near me Brampton, Best falooda near me Brampton, best falooda near me Brampton"
      },
      "cheesecake": {
        title:"Cheesecake Brampton | Creamy, Rich, Ice Cream Style",
        description: "Try the richest cheesecake and cheesecake ice cream in Brampton! Freshly made and totally crave-worthy.",
        keywords: "cheesecake near me Brampton , best cheesecake near me Brampton, Cheesecake ice cream Brampton"
      },
      "popping-soda": {
        title:"Popping Soda Brampton | Fizzy, Fun, Refreshing",
        description: "Refresh your taste buds with fizzy popping sodas in Brampton! Bursting with sweet flavors only at Rollz Ice Cream.",
        keywords: "popping soda near me Brampton, popping soda toronto Brampton"
      },
    },
    "peterborough": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Peterborough | Sweet, Fun, Fresh",
        description: "Discover Peterboroughs top rolled ice creammade live with your favorite toppings and bold, creamy flavors!",
        keywords: "rolled ice cream Peterborough, ice cream near me Peterborough, ice cream shop near me Peterborough"
      },
      "milkshakes": {
        title:"Milkshakes Peterborough | Thick, Creamy, Delicious",
        description: "Enjoy thick, creamy milkshakes in Peterborough. Freshly blended at Rollz Ice Cream with a burst of flavor!",
        keywords: "milkshake near me Peterborough, best milkshakes near me Peterborough"
      },
      "waffles": {
        title:"Belgian Waffles Peterborough | Crispy, Sweet & Fluffy",
        description: "Indulge in golden, fluffy Belgian waffles in Peterborough. Served fresh with toppings of your choice at Rollz!",
        keywords: "best belgian waffles Peterborough, belgian waffles near me Peterborough"
      },
      "faloodas": {
        title:"Falooda Peterborough | Sweet, Creamy, Indian Dessert",
        description: "Try the best falooda in Peterborough! A rich, sweet treat with exotic textures and flavors at Rollz Ice Cream.",
        keywords: "faluda near me Peterborough, Best falooda near me Peterborough, best falooda near me Peterborough"
      },
      "cheesecake": {
        title:"Cheesecake Peterborough | Creamy, Rich, Decadent",
        description: "Enjoy smooth cheesecake and cheesecake ice cream in Peterborough. A rich, creamy dessert served at Rollz!",
        keywords: "cheesecake near me Peterborough , best cheesecake near me Peterborough, Cheesecake ice cream Peterborough"
      },
      "popping-soda": {
        title:"Popping Soda Peterborough | Fizzy, Sweet, Refreshing",
        description: "Cool off with popping sodas in Peterboroughfizzy, sweet, and bursting with flavor. Only at Rollz Ice Cream!",
        keywords: "popping soda near me Peterborough, popping soda toronto Peterborough"
      },
    },
    "calgary": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Calgary | Sweet, Fresh, Handcrafted",
        description: "Explore handcrafted rolled ice cream in Calgary. Made live with flavorful toppings only at Rollz Ice Cream!",
        keywords: "rolled ice cream Calgary, ice cream near me Calgary, ice cream shop near me Calgary"
      },
      "milkshakes": {
        title:"Milkshakes Calgary | Thick, Rich, Flavor-Packed",
        description: "Indulge in Calgarys best milkshakes! Thick, creamy blends made fresh at Rollz Ice Creampure delight in every sip.",
        keywords: "milkshake near me Calgary, best milkshakes near me Calgary"
      },
      "waffles": {
        title:"Belgian Waffles Calgary | Golden, Fluffy, Sweet",
        description: "Enjoy golden, crispy Belgian waffles in Calgary. A dessert favorite, freshly made and topped your way at Rollz!",
        keywords: "best belgian waffles Calgary, belgian waffles near me Calgary"
      },
      "faloodas": {
        title:"Falooda Calgary | Exotic, Creamy Indian Dessert",
        description: "Taste Calgarys best faloodaa creamy, layered Indian dessert packed with flavor. Served fresh at Rollz Ice Cream!",
        keywords: "faluda near me Calgary, Best falooda near me Calgary, best falooda near me Calgary"
      },
      "cheesecake": {
        title:"Cheesecake Calgary | Creamy, Rich, Frozen Delight",
        description: "Try rich cheesecake or cheesecake ice cream in Calgary. A decadent, creamy dessert served fresh at Rollz Ice Cream!",
        keywords: "cheesecake near me Calgary, best cheesecake near me Calgary, Cheesecake ice cream Calgary"
      },
      "popping-soda": {
        title:"Popping Soda Calgary | Fizzy, Sweet, Flavorful Fun",
        description: "Get refreshed with popping sodas in Calgary. Fun, fizzy drinks in exciting flavors await you at Rollz Ice Cream!",
        keywords: "popping soda near me Calgary, popping soda toronto Calgary"
      },
    },

    "meadows-edmonton": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Meadows | Fresh, Live & Delicious",
        description: "Explore live-prepped rolled ice cream in Meadows Edmonton. A fun, flavorful dessert experience at Rollz Ice Cream!",
        keywords: "rolled ice cream Meadows Edmonton, ice cream near me Meadows Edmonton, ice cream shop near me Meadows Edmonton"
      },
      "milkshakes": {
        title:"Milkshakes Meadows Edmonton | Thick, Fresh & Tasty",
        description: "Enjoy Meadows Edmontons best milkshakesthick, creamy, and freshly blended with your favorite flavors at Rollz!",
        keywords: "milkshake near me Meadows Edmonton, best milkshakes near me Meadows Edmonton"
      },
      "waffles": {
        title:"Belgian Waffles Meadows | Fluffy, Crisp, Golden",
        description: "Treat yourself to crispy Belgian waffles in Meadows Edmonton. Topped to perfection at Rollz Ice Cream!",
        keywords: "best belgian waffles Meadows Edmonton, belgian waffles near me Meadows Edmonton"
      },
      "faloodas": {
        title:"Falooda Meadows Edmonton | Sweet, Creamy, Refreshing",
        description: "Dive into sweet, creamy falooda at Rollz Ice Cream Meadows Edmonton. A unique and flavorful Indian dessert!",
        keywords: "faluda near me Meadows Edmonton, Best falooda near me Meadows Edmonton, best falooda near me Meadows Edmonton"
      },
      "cheesecake": {
        title:"Cheesecake Meadows Edmonton | Creamy, Rich & Delightful",
        description: "Enjoy rich cheesecake or cheesecake ice cream in Meadows Edmonton. A decadent dessert experience at Rollz!",
        keywords: "cheesecake near me Meadows Edmonton, best cheesecake near me Meadows Edmonton, Cheesecake ice cream Meadows Edmonton"
      },
      "popping-soda": {
        title:"Popping Soda Meadows Edmonton | Fizzy, Sweet, Fun",
        description: "Try fizzy and fun popping sodas in Meadows",
        keywords: "popping soda near me Meadows Edmonton, popping soda toronto Meadows Edmonton"
      },
    },

    "waterloo": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Waterloo | Handcrafted, Sweet & Fresh",
        description: "Experience sweet, handcrafted rolled ice cream in Waterloo. Made live with your favorite flavors at Rollz Ice Cream!",
        keywords: "rolled ice cream Waterloo, ice cream near me Waterloo, ice cream shop near me Waterloo"
      },
      "milkshakes": {
        title:"Milkshakes Waterloo | Thick, Fresh, Flavorful Blends",
        description: "Sip on thick, creamy milkshakes in Waterloo! Custom-blended with rich flavors and toppings at Rollz Ice Cream.",
        keywords: "milkshake near me Waterloo, best milkshakes near me Waterloo"
      },
      "waffles": {
        title:"Belgian Waffles Waterloo | Fluffy, Golden, Sweet",
        description: "Enjoy sweet, fluffy Belgian waffles in Waterloo. Made fresh and topped just the way you likeonly at Rollz!",
        keywords: "best belgian waffles Waterloo, belgian waffles near me Waterloo"
      },
      "faloodas": {
        title:"Falooda Waterloo | Creamy, Sweet, Indian Dessert",
        description: "Discover Waterloos most refreshing faloodaslayered, creamy, and full of traditional Indian flavors at Rollz!",
        keywords: "faluda near me Waterloo, Best falooda near me Waterloo, best falooda near me Waterloo"
      },
      "cheesecake": {
        title:"Cheesecake Waterloo | Rich, Creamy & Frozen Delight",
        description: "Indulge in rich cheesecake and frozen cheesecake ice cream in Waterloo. A dessert must-try from Rollz Ice Cream!",
        keywords: "cheesecake near me Waterloo, best cheesecake near me Waterloo, Cheesecake ice cream Waterloo"
      },
      "popping-soda": {
        title:"Popping Soda Waterloo | Fizzy, Sweet, Refreshing",
        description: "Quench your thirst with fizzy popping sodas in Waterloo. A fun, flavorful twist to your dessert at Rollz Ice Cream!",
        keywords: "popping soda near me Waterloo, popping soda toronto Waterloo"
      },
    },
    "halifax": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Halifax | Fresh, Sweet & Made Live",
        description: "Discover handcrafted rolled ice cream in Halifax. Made live with bold flavors and fresh toppings at Rollz Ice Cream!",
        keywords: "rolled ice cream Halifax, ice cream near me Halifax, ice cream shop near me Halifax"
      },
      "milkshakes": {
        title:"Milkshakes Halifax | Creamy, Thick, Flavorful",
        description: "Sip Halifaxs creamiest milkshakesthick, flavorful, and made-to-order at Rollz Ice Cream. Try your favorite today!",
        keywords: "milkshake near me Halifax, best milkshakes near me Halifax"
      },
      "waffles": {
        title:"Belgian Waffles Halifax | Golden, Crispy, Sweet",
        description: "Craving waffles in Halifax? Enjoy Belgian waffles with perfect crisp and fluff, served fresh at Rollz Ice Cream!",
        keywords: "best belgian waffles Halifax, belgian waffles near me Halifax"
      },
      "faloodas": {
        title:"Falooda Halifax | Sweet, Creamy, Indian Delight",
        description: "Taste authentic falooda in Halifaxrich, creamy, and full of textures. A traditional Indian dessert at Rollz!",
        keywords: "faluda near me Halifax, Best falooda near me Halifax, best falooda near me Halifax"
      },
      "cheesecake": {
        title:"Cheesecake Halifax | Creamy, Rich, Frozen Bliss",
        description: "Try smooth cheesecake and cheesecake ice cream in Halifax. Freshly made indulgence awaits at Rollz Ice Cream!",
        keywords: "cheesecake near me Halifax, best cheesecake near me Halifax, Cheesecake ice cream Halifax"
      },
      "popping-soda": {
        title:"Popping Soda Halifax | Fizzy, Fun, Flavorful Sips",
        description: "Get fizzy and fun with popping sodas in Halifax. Sweet, refreshing, and perfect with your dessert at Rollz Ice Cream!",
        keywords: "popping soda near me Halifax, popping soda toronto Halifax"
      },
    },
    "lebovic-scarborough": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Scarborough | Fresh, Fun, Flavorful",
        description: "Try handcrafted rolled ice cream at Rollz Lebovic, Scarboroughmade live with sweet toppings and creamy goodness!",
        keywords: "rolled ice cream Scarborough, ice cream near me Scarborough, ice cream shop near me Scarborough"
      },
      "milkshakes": {
        title:"Milkshakes Scarborough | Thick, Creamy & Delicious",
        description: "Savor Scarboroughs best milkshakes! Freshly blended, rich, and full of flavoronly at Rollz Ice Cream, Lebovic.",
        keywords: "milkshake near me Scarborough, best milkshakes near me Scarborough"
      },
      "waffles": {
        title:"Belgian Waffles Scarborough | Golden, Sweet, Crisp",
        description: "Enjoy golden, crispy Belgian waffles in Scarboroughs Lebovic area. A dessert classic served fresh at Rollz!",
        keywords: "best belgian waffles Scarborough, belgian waffles near me Scarborough"
      },
      "faloodas": {
        title:"Falooda Scarborough | Sweet, Creamy Indian Dessert",
        description: "Taste the best falooda in Scarborough at Rollz Lebovic. A rich, refreshing Indian dessert full of texture and flavor!",
        keywords: "faluda near me Scarborough, Best falooda near me Scarborough, best falooda near me Scarborough"
      },
      "cheesecake": {
        title:"Cheesecake Scarborough | Creamy, Rich, Frozen Bliss",
        description: "Indulge in rich cheesecake and cheesecake ice cream in Scarborough. Creamy, smooth desserts await at Rollz!",
        keywords: "cheesecake near me Scarborough, best cheesecake near me Scarborough, Cheesecake ice cream Scarborough"
      },
      "popping-soda": {
        title:"Popping Soda Scarborough | Fizzy, Fun, Flavorful Sips",
        description: "Refresh with fizzy popping sodas in Scarborough. Flavor-packed drinks served chilled at Rollz Ice Cream, Lebovic!",
        keywords: "popping soda near me Scarborough, popping soda toronto Scarborough"
      },
    },
    "collingwood": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Collingwood | Fresh, Handcrafted Delight",
        description: "Try handcrafted rolled ice cream in Collingwood! Watch your dessert made live at Rollz Ice Cream with fresh flavors.",
        keywords: "rolled ice cream Collingwood, ice cream near me Collingwood, ice cream shop near me Collingwood"
      },
      "milkshakes": {
        title:"Milkshakes Collingwood | Thick, Creamy, Refreshing",
        description: "Discover the best milkshakes in Collingwoodrich, creamy, and freshly made at Rollz Ice Cream with bold flavors!",
        keywords: "milkshake near me Collingwood, best milkshakes near me Collingwood"
      },
      "waffles": {
        title:"Belgian Waffles Collingwood | Golden, Sweet, Delicious",
        description: "Treat yourself to golden Belgian waffles in Collingwood. Crisp on the outside, soft insideserved hot at Rollz!",
        keywords: "best belgian waffles Collingwood, belgian waffles near me Collingwood"
      },
      "faloodas": {
        title:"Falooda Collingwood | Creamy, Sweet, Refreshing Dessert",
        description: "Cool off with the best falooda in Collingwood! Creamy, sweet, and texturedyour go-to Indian dessert at Rollz.",
        keywords: "faluda near me Collingwood, Best falooda near me Collingwood, best falooda near me Collingwood"
      },
      "cheesecake": {
        title:"Cheesecake Collingwood | Rich, Creamy & Irresistible",
        description: "Savor the finest cheesecake and cheesecake ice cream in Collingwoodsmooth, indulgent, and served fresh at Rollz!",
        keywords: "cheesecake near me Collingwood, best cheesecake near me Collingwood, Cheesecake ice cream Collingwood"
      },
      "popping-soda": {
        title:"Popping Soda Collingwood | Fizzy, Fun, Flavorful Sips",
        description: "Enjoy fizzy, flavor-bursting popping sodas in Collingwood. Perfectly refreshing drinks served at Rollz Ice Cream!",
        keywords: "popping soda near me Collingwood, popping soda toronto Collingwood"
      },
    },
    "surrey": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream Surrey | Sweet, Fresh, Handcrafted",
        description: "Try the freshest rolled ice cream in Surrey! Made live with flavorful toppings and creamy base at Rollz Ice Cream.",
        keywords: "rolled ice cream Surrey, ice cream near me Surrey, ice cream shop near me Surrey"
      },
      "milkshakes": {
        title:"Milkshakes Surrey | Thick, Flavorful, Refreshing",
        description: "Savor creamy, thick milkshakes in Surreyrich in taste, blended fresh at Rollz Ice Cream with fun flavors you love!",
        keywords: "milkshake near me Surrey, best milkshakes near me Surrey"
      },
      "waffles": {
        title:"Belgian Waffles Surrey | Golden, Sweet, Crispy",
        description: "Enjoy the perfect Belgian waffles in Surreyfluffy, golden, and topped just right. Only at Rollz Ice Cream!",
        keywords: "best belgian waffles Surrey, belgian waffles near me Surrey"
      },
      "faloodas": {
        title:"Falooda Surrey | Creamy, Cool, Indian Dessert",
        description: "Refresh with the best falooda in Surrey. A creamy, flavorful, and traditional Indian dessert from Rollz Ice Cream!",
        keywords: "faluda near me Surrey, Best falooda near me Surrey, best falooda near me Surrey"
      },
      "cheesecake": {
        title:"Cheesecake Surrey | Rich, Creamy, Dessert Perfection",
        description: "Indulge in creamy cheesecake or cheesecake ice cream in Surrey. A rich dessert made fresh at Rollz Ice Cream!",
        keywords: "cheesecake near me Surrey, best cheesecake near me Surrey, Cheesecake ice cream Surrey"
      },
      "popping-soda": {
        title:"Popping Soda Surrey | Fizzy, Sweet, Flavorful Fun",
        description: "Try refreshing popping sodas in Surreyfizzy, sweet, and bursting with bold flavor at Rollz Ice Cream!",
        keywords: "popping soda near me Surrey, popping soda toronto Surrey"
      },
    },

      "vancouver": {
      "rolled-ice-cream": {
        title:"Rolled Ice Cream vancouver | Fresh, Fun, Flavorful",
        description: "Try handcrafted rolled ice cream at Rollz Lebovic, vancouver—made live with sweet toppings and creamy goodness!",
        keywords: "rolled ice cream vancouver, ice cream near me vancouver, ice cream shop near me vancouver"
      },
      "milkshakes": {
        title:"Milkshakes vancouver | Thick, Creamy & Delicious",
        description: "Savor vancouver’s best milkshakes! Freshly blended, rich, and full of flavor—only at Rollz Ice Cream, Lebovic.",
        keywords: "milkshake near me vancouver, best milkshakes near me vancouver"
      },
      "waffles": {
        title:"Belgian Waffles vancouver | Golden, Sweet, Crisp",
        description: "Enjoy golden, crispy Belgian waffles in vancouver’s Lebovic area. A dessert classic served fresh at Rollz!",
        keywords: "best belgian waffles vancouver, belgian waffles near me vancouver"
      },
      "faloodas": {
        title:"Falooda vancouver | Sweet, Creamy Indian Dessert",
        description: "Taste the best falooda in vancouver at Rollz Lebovic. A rich, refreshing Indian dessert full of texture and flavor!",
        keywords: "faluda near me vancouver, Best falooda near me vancouver, best falooda near me vancouver"
      },
      "cheesecake": {
        title:"Cheesecake vancouver | Creamy, Rich, Frozen Bliss",
        description: "Indulge in rich cheesecake and cheesecake ice cream in vancouver. Creamy, smooth desserts await at Rollz!",
        keywords: "cheesecake near me vancouver, best cheesecake near me vancouver, Cheesecake ice cream vancouver"
      },
      "popping-soda": {
        title:"Popping Soda vancouver | Fizzy, Fun, Flavorful Sips",
        description: "Refresh with fizzy popping sodas in vancouver. Flavor-packed drinks served chilled at Rollz Ice Cream, Lebovic!",
        keywords: "popping soda near me vancouver, popping soda toronto vancouver"
      },
    },
  }

  return (
    <>
    
      
      <Helmet>
        <meta
          name="keyword"
          content={metadata[localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-") || ""]?.[category_name]?.keywords || ""}
        />
        <meta
          name="title"
          content={metadata[localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-") || ""]?.[category_name]?.title || ""}
        />
        <meta
          name="description"
          content={metadata[localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-") || ""]?.[category_name]?.description || ""}
        />
      </Helmet>


      {isLoading && <Loader />}
      <div className="menu_page">
        <section className="menu_section">
          <div className="menuPage_container">
            <div className="container menuPage_wrapper">
              <div className="flex-column flex-md-row menu_container">
                <Card className="col-12 col-md-3 col-sm-12 d-flex flex-column justify-content-start menu_category">
                  <h5 className="d-flex align-content-center justify-content-between text-white">
                    Categories <span></span>
                    <span
                      className="d-block d-md-none"
                      onClick={() => setShowCat(!showCat)}
                    >
                      <i className="bi bi-list"></i>
                    </span>
                  </h5>

                  <div
                    className={`d-flex menuPage_items flex-column justify-content-start my-3 d-md-block ${showCat ? "d-md-block" : "d-none"
                      }`}
                    id="rolled-ice-cream"
                  >
                    {categoryList
                      .filter((obj) => obj.subcategory !== 1)
                      .map((obj, i) => {
                        if (obj.is_active == 1) {
                          return (
                            <div key={i} className="px-4 py-2">
                              <p
                                className={
                                  // obj.slug == main_url
                                  activeState === obj.slug && !menu_id 
                                    ? "btn-active-menu p-2"
                                    : ""
                                }
                                onClick={() => {
                                  if (obj.slug === "rolled-ice-cream") {
                                    setData(rolledIceCreamsData)
                                  }
                                  setShowCat(!showCat)
                                  setActiveState(obj.slug)
                                  setMenuId(null);
                                }
                                }
                                
                              >
                                <Link
                                  to={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-")}/${obj.slug}`}
                                  // onClick={() => console.log("Obj Menu Name", obj.menu_name)}
                                >
                                  {obj.menu_name}
                                </Link>
                              </p>
                              {
                                obj.slug == "rolled-ice-cream" ? (
                                  <>
                                    {categoryList
                                      .filter((res) => res.subcategory === 1)
                                      .map((res, i) => (
                                        <ul className="my-1" key={i}>
                                          <li style={{ listStyle: "none" }}>
                                            <p
                                              className={`p-2 ${main_url == "rolled-ice-cream" && res.id == menu_id
                                                  ? "side-active"
                                                  : ""
                                                }`}
                                              onClick={() => {
                                                setShowCat(!showCat)
                                                setMenuId(res.id);
                                              } 
                                              }
                                            >
                                              <a
                                                onClick={() => {
                                                  if (
                                                    main_url !==
                                                    "rolled-ice-cream"
                                                  ) {
                                                    navigate(
                                                      `${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-")}/rolled-ice-cream`
                                                    );
                                                    setData(
                                                      allData.filter(
                                                        (obj) =>
                                                          obj.menu_id == res.id
                                                      )
                                                    );
                                                    // console.log("Products In Subcategory",  allData.filter(
                                                    //   (obj) =>
                                                    //     obj.menu_id == res.id
                                                    // ))
                                                    setMenuId(res.id);
                                                  }else {
                                                    setData(
                                                      allData.filter(
                                                        (obj) =>
                                                          obj.menu_id == res.id
                                                      )
                                                    );
                                                    setMenuId(res.id);
                                                  }
                                                }}
                                                className="cursor-point d-flex align-items-start"
                                              >
                                                {res.menu_name} 
                                              </a>
                                            </p>
                                          </li>
                                        </ul>
                                      ))}
                                  </>


                                ) : null}
                            </div>
                          );
                        }
                      })}
                  </div>
                </Card>

                <div className="col-12 col-md-9  col-sm-12 d-flex flex-column">
                  <div className="menu_add mb-3">
                    <img
                      src={menuOffer}
                      className="img-fluid"
                      alt="advertising"
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "fill",
                      }}
                    />
                  </div>
                  <div className="col-12  d-flex flex-column align-items-start menuPage_products">
                    <Row className="col-12 products_container">
                      {data.map((product, index) => (
                        <div
                          key={index}
                          className="col-12 col-md-3 col-sm-4 menu_card px-0 px-sm-2 py-2"
                        >
                          <div className="d-flex flex-column align-items-center justify-content-center single_product">
                            <div className="single_product_img">
                              <img
                                src={product.img}
                                alt="product_img"
                                className="img-fluid"
                                loading="lazy"
                              />
                            </div>
                            <div className="my-2 single_product_detail">
                              <h6 className="text-center py-2">
                                {product.menu_item_name}
                              </h6>
                            </div>
                          </div>
                        </div>
                      ))}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Conatc form  */}
        <section className="menuPage_contact">
          <div className="container menuContact">
            <div className="text-center getmenu_heading mb-4">
              <h3>Get Our Menu </h3>
            </div>
            <form onSubmit={onLocationMenu}>
              <div className="d-flex flex-column flex-md-row flex-wrap row-gap-3 align-items-center justify-content-center gap-3">
                <div className="col-12 col-md-4 col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    value={person_name}
                    // required
                    onChange={(e) => setPersonName(e.target.value)}
                  ></input>
                  {errors.person_name_error && (
                    <span className="bg-white text-danger error fw-bold ms-0 px-2 py-1">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      {errors.person_name_error}
                    </span>
                  )}
                </div>
                <div className="col-12 col-md-4 col-sm-10 d-fle flex-column gap-2">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email"
                    value={email}
                    // required
                    onChange={(e) => setEmail(e.target.value)}
                  ></input>
                  {errors.email_error && (
                    <span className="bg-white text-danger error fw-bold ms-0 px-2 py-1">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      {errors.email_error}
                    </span>
                  )}
                </div>
                <div className="col-12 col-md-3 col-sm-10">
                  <div className="order-online">
                    <button className="blue-btn hero-anchor" type="submit">
                      <div className="order-online-trans-1"></div>
                      <div className="order-online-trans-2"></div>
                      Get Menu
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </section>

        <section className="menuPage_para_container">
          <div className="container">
            <div className="menuPage_para">
              <h2>{introTitle}</h2>
              <p>{introDesc}</p>
            </div>
          </div>
        </section>

        {/* <Footer color="#ffecf0" /> */}
      </div>
    </>
  );
};

export default NewMenuPage;
